module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Associate with organization","placeholder":"Search organization by organization name or CVR"},"da":{"title":"Tilknyt til organisation","placeholder":"Søg organisation pr. organisationsnavn eller CVR"}}')
  delete Component.options._Ctor
}
